import type { Schemas } from "@/types/api";
// ---------------------------------------------------------------------------
// Types for Melhoria Contínua — Registo de Melhoria (AFI.12A)
// ---------------------------------------------------------------------------


export type RegistoMelhoria = Schemas["RegistoMelhoriaRead"];

// ---------------------------------------------------------------------------
// Option constants
// ---------------------------------------------------------------------------

export const TIPO_ACAO_OPTIONS = [
  "Ação Corretiva",
  "Ação de Correção",
  "Ação de Melhoria",
] as const;

export const FOLHA_LABELS: Record<string, string> = {
  NC_OM_Reclam: "NC / OM / Reclamação",
  Auditorias: "Auditorias",
};

// ---------------------------------------------------------------------------
// Badge config
// ---------------------------------------------------------------------------

export const ESTADO_BADGE: Record<string, { label: string; className: string }> = {
  Fechada:      { label: "Fechada",     className: "bg-green-100 text-green-700 border-green-200" },
  "Em Curso":   { label: "Em curso",    className: "bg-blue-100 text-blue-700 border-blue-200" },
  "Não Eficaz": { label: "Não eficaz",  className: "bg-red-100 text-red-700 border-red-200" },
  Transita:     { label: "Transita",    className: "bg-amber-100 text-amber-700 border-amber-200" },
};

export const TIPO_BADGE: Record<string, { label: string; className: string }> = {
  "Não Conformidade": { label: "NC",  className: "bg-red-100 text-red-700 border-red-200" },
  "Reclamação":       { label: "RC",  className: "bg-orange-100 text-orange-700 border-orange-200" },
  "Ação de Melhoria": { label: "AM",  className: "bg-purple-100 text-purple-700 border-purple-200" },
  "Sugestão":         { label: "SUG", className: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const TIPO_ACAO_BADGE: Record<string, string> = {
  "Ação Corretiva":   "AC",
  "Ação de Correção": "CC",
  "Ação de Melhoria": "AM",
};
